// Configuration for proximity-based search feature

export const SEARCH_CONFIG = {
  // Default search radius in kilometers
  DEFAULT_RADIUS_KM: 10,
  
  // Maximum search radius in kilometers
  MAX_RADIUS_KM: 50,
  
  // Whether to show distance in search results
  SHOW_DISTANCE_IN_RESULTS: true,
  
  // Whether to automatically expand search radius when no results found
  AUTO_EXPAND_RADIUS: true,
  
  // Progressive radius expansion steps in kilometers
  RADIUS_EXPANSION_STEPS: [10, 20, 30, 50],
} as const;

